module.exports = __webpack_public_path__ + "fonts/GaramontAmsterdamBQ-Medium.e4059131.woff2";